<template>
  <div>
    <div class="wrapper-page">
      <div class="card overflow-hidden account-card mx-3">
        <div class="bg-primary p-4 text-white text-center position-relative">
          <h4 class="font-20 m-b-5">iRecharge Merchant Collection</h4>
          <br />
          <a href="#" class="logo logo-admin">
            <img src="assets/images/logo.png" height="35" alt="logo" />
          </a>
        </div>
        <div class="account-card-content">
          <form class="form-horizontal m-t-30" id="formLogin">
            <div class="form-group">
              <label for="username">Username</label>
              <input
                type="text"
                class="form-control"
                placeholder="Username"
                v-model="fields.inputEmail"
              />
            </div>
            <div class="form-group">
              <label for="userpassword">Password</label>
              <input
                type="password"
                class="form-control"
                placeholder="Enter password"
                v-model="fields.inputPassword"
              />
            </div>
            <div class="form-group row m-t-20">
              <div class="col-sm-6 text-center">
                <div class="clearfix">
                  <button
                    id="loginBtn"
                    class="btn btn-primary w-md waves-effect waves-light float-left"
                    @click.prevent="login()"
                    :disabled="loading"
                  >
                    Log In
                    <i class="fas fa-sign-in-alt" aria-hidden="true"></i>
                  </button>
                  <img
                    height="30"
                    width="30"
                    class="float-right"
                    v-if="loading"
                    src="@/assets/loader.gif"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      fields: {
        relocate: "login",
        action: "login"
      },
      username: ""
    };
  },
  mounted() {
    sessionStorage.clear();
     if (this.$router.currentRoute.path == "/login") {
      this.$parent.visible = false;
    }
  },
  methods: {
    login() {
      if (this.ValidateData()) {
        this.loading = true;
        // set form data
        var bodyFormData = new FormData();
        bodyFormData.set("relocate", "login");
        bodyFormData.set("action", "login");
        bodyFormData.set("inputEmail", this.fields.inputEmail);
        bodyFormData.set("inputPassword", this.fields.inputPassword);
        this.axios
          .post("https://irecharge.com.ng/control_member.php", bodyFormData)
          .then(response => {
            // console.log(response);
            if (response.data.status == 1 || response.data.status == 100) {
              sessionStorage.setItem("phone", response.data.phone);
              sessionStorage.setItem("userType", 1);
              sessionStorage.setItem("level", response.data.level);
              // Status 1 = Don't show the welcome message
              sessionStorage.setItem("status", 1);
              sessionStorage.setItem("userid", response.data.userid);
              sessionStorage.setItem("vendor_id", response.data.vendor_id);
              sessionStorage.setItem("vendor_name", response.data.vendor_name);
              sessionStorage.setItem(
                "vendor_address",
                response.data.vendor_address
              );
              sessionStorage.setItem("username", this.fields.inputEmail);
              this.$noty.success(response.data.message);
              //window.location.assign("http://localhost:8080/dashboard");
              this.$parent.visible = true;
              this.$router.push("dashboard");
            } 
            else if(response.data.status == 100) {
              this.$noty.warning("Not Authorised");
            }
            else 
            {
              this.$noty.warning(response.data.message);
            }
            this.loading = false;
          })
          .catch(error => {
            this.$noty.danger("Could not send request, check network.");
            this.loading = false;
          });
      }
    },
    ValidateData() {
      if (this.fields.inputEmail) 
      {
        if (this.fields.inputPassword) {
          return true;
        } else {
          this.$noty.warning("Password field is required!");
        }
      } else {
        this.$noty.warning("E-mail / Phone field is required!");
      }
    },
  }
};
</script>
<style scoped >
</style>